// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  apiDomain: 'iotapitest.cyberpower.com',
  // apiIotUrl: 'https://iottest.powermastercloud.com',
  apiIotUrl: 'https://iotapitest.cyberpower.com',
  // apiSerivceUrl: 'https://iottest.powermastercloud.com',
  apiSerivceUrl: 'https://iotapitest.cyberpower.com',
  rWCCUrl: 'http://192.168.4.1',
  azureApiServiceUrl: 'https://powerpaneldemoservice.cyberpower.com',
  cyberpowerUrl: 'https://test.cyberpower.com/global/en',
  WebVersion: '1.10.4',
  // tslint:disable-next-line:max-line-length
  PowerPanelCloudGoogleOAuthUrl: 'https://accounts.google.com/o/oauth2/v2/auth?scope=https%3A//www.googleapis.com/auth/userinfo.profile%20https://www.googleapis.com/auth/userinfo.email&include_granted_scopes=true&response_type=token&prompt=consent{1}&redirect_uri={0}&client_id=968076468688-3ri8khc4gftv38qicf1le52nrfi5ce8s.apps.googleusercontent.com',
  // tslint:disable-next-line:max-line-length
  PowerPanelCloudFacebookOAuthUrl: 'https://www.facebook.com/dialog/oauth?client_id=398107632730962&scope=email&auth_type=reauthenticate&redirect_uri={0}{1}',
  // tslint:disable-next-line:max-line-length
  PowerPanelCloudAppleOAuthUrl: 'https://appleid.apple.com/auth/authorize?client_id=com.cyberpower.android&response_type=code&scope=email%20name&response_mode=form_post{1}&redirect_uri={0}',
  HomePageUrl: 'https%3A//powerpaneldemo.cyberpower.com/',
  RedirectAuthApiUrl: 'https%3A//powerpaneldemo.cyberpower.com/api/apple/auth/signin',
  IdentifierUrl: 'https://powerpaneldemo.cyberpower.com/account/{0}',
  ReplyUrl: 'https://powerpaneldemo.cyberpower.com/login/callback'
};

// accountKey 僅存於後端 config.json / .env；SAS 由 POST /api/azureblobstorage/generatesharedaccesssignature 取得
export const azureBlobStorage = {
  accountName: 'powerpaneldemo',
  containerName: 'firmware'
};

export const isODM = false;
// export const Confirm_button = '';
export const Confirm_button = 'ui-button-danger';

export const aesHash = {
  ivKey: '!Cyberpower!Tp08',
  secretKey: '415eb0f4fc031c6193255b1248d4ba25'
};

export const SSOURL = {
  // backendURL: 'http://localhost:8080',
  // clientURL: 'http://localhost:4200',
  backendURL: 'https://powerpaneldemo.cyberpower.com',
  clientURL: 'https://powerpaneldemo.cyberpower.com'
};

export const RECAPTCHA_V2_INVISIBLE_SITE_KEY = '6LfDj0krAAAAAD9KlrtOfpP1Ixs6gQ1fQZE9CdSk';
